import { render, staticRenderFns } from "./Drumroll.vue?vue&type=template&id=435d5f29&scoped=true"
import script from "./Drumroll.vue?vue&type=script&lang=js"
export * from "./Drumroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435d5f29",
  null
  
)

export default component.exports